module.exports = __webpack_public_path__ + "static/media/category.cf1239ab.svg";